var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.965 7.612a3.214 3.214 0 012.256 2.282c.533 2.013.533 6.213.533 6.213s0 4.2-.534 6.213a3.214 3.214 0 01-2.255 2.282c-1.989.54-9.965.54-9.965.54s-7.976 0-9.966-.54A3.214 3.214 0 013.78 22.32c-.533-2.013-.533-6.213-.533-6.213s0-4.2.533-6.213a3.214 3.214 0 012.255-2.282c1.99-.54 9.966-.54 9.966-.54s7.976 0 9.965.54zm-12.574 4.682v7.626l6.667-3.813-6.667-3.813z",
    fill: "#fff"
  })));
}
export default SvgYoutube;